import React, { SyntheticEvent, useEffect, useState } from "react";
import {
  isOperationPermitted,
  showIcons,
} from "../../helpers/action-permission-helper";
import LoaderButton from "../../shared-components/Button/LoaderButton";
import { formatMessage } from "../../translations/format-message";
import { FormattedMessage } from "react-intl";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import Grid from "../../shared-components/Grid/Grid";
import Pagination from "../../shared-components/Grid/Pagination";
import no_user from "../../assets/Images/svg/no-user.svg";
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from "../../models/ICommon";
import { useStore } from "../../contexts/StoreProvider";
import { observer } from "mobx-react";
import userSettingEnum from "../../constants/user-setting-enum";
import { ActionFormatter } from "../../shared-components/Grid/GridFormatter";
import { faMicrochip, faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import systemModuleEnum from "../../constants/system-module-enum";
import toast from "react-hot-toast";
import AddPopupHOC from "../../shared-components/popup/add/add-popup-hoc";
import SlidingPanel from "react-sliding-side-panel";
import fotaFileTypeEnum from "../../constants/fota-file-type-enum";
import ShowPopupHOC from "../../shared-components/popup/show/show-popup-hoc";
import config from "../../helpers/config-helper";
import DeletePopup from "../../shared-components/popup/delete/delete-popup";
import DeletePopupHOC from "../../shared-components/popup/delete/delete-popup-hoc";
import ScheduleFirmwareUpdate from "../fota-tenant/components/schedule-firmware-update";
import ScheduleUpdatePopupHOC from "../fota-tenant/hoc/schedule-update-popup-hoc";
import FotaTenantDetails from "../fota-tenant/components/fota-tenant-detail";
import RoutesConstants from "../../shared-components/Routes/routes.constants";
import { IFotaTenantReleaseList } from "../../models/response/IFotaResponse";
import { useHistory } from "react-router-dom";

const appConfig = config();

const FotaReleaseSchedulerHistory = (props: any) => {
  const history = useHistory();
  const { preferencesStore, releaseSchedulerHistoryStore, fotaStore } = useStore();
  const {
    error,
    inProgress,
    reset,
    addUpdateReleaseSchedulerHistoryState,
    resetAddUpdateReleaseSchedulerHistoryState,
    GetReleaseSchedulerHistoryListService,
    getReleaseSchedulerHistoryList,
    resetReleaseSchedulerHistoryState,
    DeleteReleaseSchedulerHistoryService,
    resetDeleteReleaseSchedulerHistoryState,
    deleteReleaseSchedulerHistoryState,
    releaseSchedulerHistoryList,
    DownloadReleaseSchedulerDeviceListBySchedulerIdService,
    resetDownloadReleaseSchedulerDeviceListState,
    downloadReleaseSchedulerDeviceListState,
    resetStore
  } = releaseSchedulerHistoryStore;
  const {
    userSetting,
    setUserSetting,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;
  const {isSelectedView} = fotaStore;
  const pageLimitOptions: Array<number> = [10, 50, 100, 1000];
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [openPanel, setOpenPanel] = useState(false);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
    
  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.fotaLimitConfig,
    isPageLimitChange: false,
  });
  
  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });
  const selectedRecord : IFotaTenantReleaseList | null = props.location?.state ? props.location.state.selectedRecord : null;
  const onPageChanged = (pageNumber: number) => {
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: releaseSchedulerHistoryList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.FotaLimitConfig, parseInt(evt.target.value));
  };

  /**
   * This function calls the "GetFotaMzlReleaseListService" store funtion that get fota release list from API
   */
  const callGetFotaListService = () => {
    if(selectedRecord?.Id)
      GetReleaseSchedulerHistoryListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        isSelectedView,
        selectedRecord.Id
      );
  };

  /**
   * This function shows the add group pop up from where we can add new group and update existing group prootcol. we use id to identify
   * that we are adding or updating group.
   * "Id == -1" : we are adding new group
   * "Id != -1" : means we are updating existing group
   */
  const openAddPopupHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    closePanelhandler();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };
  
  const openSchedulePopupHandler = (row: { Id: number, Version: string }, event: SyntheticEvent) => {
    if(selectedRecord?.Id){
      event.stopPropagation();
      closePanelhandler();
      setSelectedRow(row);
      setSelectedId(row.Id);
      props.scheduleUpdateToggleHandler();
    }
  };

  /**
   * This function shows the delete user confirmation popup component and sets the seleted user Id
   */
  const deleteClickHandler = (row: { Id: number }, event: SyntheticEvent) => {
    event.stopPropagation();
    setSelectedId(row.Id);
    props.deletePopupToggleHandler();
  };
  
  const historyClickHandler = (row: IFotaTenantReleaseList, event: SyntheticEvent) => {
    event.stopPropagation();
    history.push({
      pathname: RoutesConstants.FotaDeviceStatus,
      state: {
        selectedScheduler: {...selectedRecord},
        selectedRecord: {...row},
        
      }
    })
  };

  /**
   * This function deletes the user by providing Id to the Api
   */
  const deleteHandler = () => {
    if(selectedRecord)
      DeleteReleaseSchedulerHistoryService(selectedId, isSelectedView);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageLimitInfo.pageLimit" of the useEffect changed.
   */
  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      callGetFotaListService();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimitInfo.pageLimit]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "GroupList" of the useEffect changed.
   */
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      totalPages: releaseSchedulerHistoryList?.PagingDetails?.TotalPages,
      isPagerChange: false,
    });
    setDisablePagination(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getReleaseSchedulerHistoryList]);

  useEffect(() => {
    callGetFotaListService();
    return(()=>{
      resetStore();
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "pageInfo.currentPage" of the useEffect changed.
   */
  useEffect(() => {
    if (pageInfo.isPagerChange) {
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "deleteFotaSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (deleteReleaseSchedulerHistoryState.success) {
      // toast.success(formatMessage("deleted_success"));
      resetDeleteReleaseSchedulerHistoryState();
      props.deletePopupToggleHandler();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteReleaseSchedulerHistoryState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateReleaseSchedulerHistoryState.success) {
      resetAddUpdateReleaseSchedulerHistoryState();
      callGetFotaListService();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateReleaseSchedulerHistoryState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateGroupstate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (downloadReleaseSchedulerDeviceListState.success) {
      resetDownloadReleaseSchedulerDeviceListState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadReleaseSchedulerDeviceListState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "error" of the useEffect changed.
   */
  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "islanguageChanged" of the useEffect changed.
   */
  useEffect(() => {
    if (islanguageChanged) {
      callGetFotaListService();
      updateLanguageChangedFlag();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [islanguageChanged]);

  function rowClassFormat(row: any, rowIdx: number) {
    let className: string = "";
    if (selectedId && row.Id === selectedId) {
      className = "bg-row SelectedRow";
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any, rowIndex: number) => {
    setSelectedId(row.Id);
    setSelectedRow(row);
    setOpenPanel(true);
  };

  const closePanelhandler = () => {
    resetReleaseSchedulerHistoryState();
    setOpenPanel(false);
    setSelectedId(0);
    setSelectedRow({});
    // tenantStore.reset();
  };

  // const downloadDeviceListHandler = (row: ISchedulerHistoryList, event: SyntheticEvent) => {
  //   event.stopPropagation();
  //   DownloadReleaseSchedulerDeviceListBySchedulerIdService(row.Id, isSelectedView)
  //   closePanelhandler();
  // };

  const actionIcons: IActionFormatter[] = showIcons(
    [
      // {
      //   dataField: "isDownload",
      //   handler: downloadDeviceListHandler,
      //   icon: faDownload,
      //   isDisable: true,
      //   title: "download",
      //   action: "view",
      //   varient: "danger",
      // },
      {
        dataField: "isEdit",
        handler: openSchedulePopupHandler,
        icon: faPencilAlt,
        isDisable: true,
        title: "edit",
        action: "edit",
        varient: "primary",
      },
      {
        dataField: "isDelete",
        handler: deleteClickHandler,
        icon: faTrashAlt,
        isDisable: true,
        title: "delete",
        action: "delete",
        varient: "danger",
      },
      {
        dataField: "isHistory",
        handler: historyClickHandler,
        icon: faMicrochip,
        isDisable: false,
        title: "devices_status",
        varient: "primary",
      },
    ],
    systemModuleEnum.Fota
  );
  
  const columns: any = [
    {
      dataField: "ScheduleDate",
      text: formatMessage("schedule_date_utc"),
    },
    // {
    //   dataField: "Status",
    //   text: formatMessage("status"),
    //   formatter: (cell: any, row: any) => {
    //     return (
    //       <>
    //         <span>{row.Id%2==0 ? "Pending" : "Complete"}</span>
    //       </>
    //     );
    //   },
    // },
    {
      dataField: "NoOfDevicesInSchedule",
      text: formatMessage("no_of_devices_in_schedule"),
    },
    {
      dataField: "Description",
      text: formatMessage("fota_desc"),
      title: (cell: string, row: any) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: "",
      formatter: ActionFormatter(actionIcons),
      text: formatMessage("actions"),
      hidden: actionIcons.length === 0 ? true : false,
    },
  ];

  return (
    <>
      {props.showScheduleUpdatePopup && (
        <ScheduleFirmwareUpdate
          view={isSelectedView}
          version={selectedRecord?.Version || ""}
          schedulerId={selectedId}
          releaseId={selectedRecord?.Id || -1}
          modalClosed={props.scheduleUpdateToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_fota"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_fota_confirm"
          isLoading={deleteReleaseSchedulerHistoryState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div id="moveContent">
          <div className="container-fluid">
            <div className="row g-0  align-items-center">
              <div className="col-sm-6 col-12">
                <div className="filter-left-area ps-5">
                  <ul className="d-flex align-items-center mt-1">
                    <li title={formatMessage("back")}>
                      <button role="" className="btn btn-secondary" 
                        onClick={() => props.history.push(RoutesConstants.Fota)}>
                        <i className="fa fa-arrow-left"></i>
                      </button>
                    </li>
                    <li className="ms-2">
                      <p className="h5 mb-0 d-inline">
                        <FormattedMessage id="schedule_history" />
                      </p>
                        {
                          selectedRecord?.Id &&
                          <small className="text-muted ms-2">
                            (<span className="me-2"><FormattedMessage id="version" />: {selectedRecord.Version}</span> |
                            <span className="ms-2"><FormattedMessage id="file_type" />: {fotaFileTypeEnum[selectedRecord.FileType]}</span>)
                          </small>
                        }
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-sm-6 col-12">
                <div className="add-list">
                  <ul className="d-flex align-items-center">
                    {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
                      <li title={formatMessage("add_schedule")}>
                        <LoaderButton
                          id="fotaUpdateModal"
                          text="add_schedule"
                          onClick={(
                            e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                          ) => openSchedulePopupHandler({ Id: -1, Version: selectedRecord?.Version || "" }, e)}
                        />
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div>
        <div className="row pt-2">
          <div className="col-6">
            <label className="text-muted bold">
              <FormattedMessage id="version" />:{" "}
            </label>
          </div>
          <div className="col-6">
            <p className="mw-100">
              <span>
                {1.2}
              </span>
            </p>
          </div>
        </div>
        <div className="row pt-2">
          <div className="col-6">
            <label className="text-muted bold">
              <FormattedMessage id="file_type" />:{" "}
            </label>
          </div>
          <div className="col-6">
            <p className="mw-100">
              <span>
                {"Hex"}
              </span>
            </p>
          </div>
        </div>
        <h3>
          <FormattedMessage id="schedule_history" />:
        </h3>
      </div> */}
      
      <div className="table_items_list">
        {(inProgress || downloadReleaseSchedulerDeviceListState.inProgress) && <FormLoader loading={(inProgress || downloadReleaseSchedulerDeviceListState.inProgress)} />}
        {getReleaseSchedulerHistoryList.length > 0 ? (
          <div
            className={`card mt-3 changingPanel ${
              openPanel ? "panelOpen" : ""
            }`}
          >
            <div className="tableDesign row-eq-height tableDevices ">
              <div className="table-responsive" data-testid="table">
                <Grid
                  data={getReleaseSchedulerHistoryList}
                  columns={columns}
                  keyField="Id"
                  loading={inProgress}
                  // rowEvents={{ onClick: rowEvents }}
                  rowClasses={rowClassFormat}
                />
              </div>
            </div>

            {getReleaseSchedulerHistoryList.length > 0 ? (
              <div className="row g-0 p-2 tableFooter">
                <div className="col-sm-6 pt-1">
                  <FormattedMessage id="show" />
                  <select
                    data-testid="pageSelect"
                    className="pageLimit"
                    onChange={onPageLimitChanged}
                    value={pageLimitInfo.pageLimit}
                  >
                    {pageLimitOptions.map((op: any) => (
                      <option key={op} value={op}>
                        {op}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6 d-flex justify-content-sm-end">
                  <Pagination
                    isRefreshPage={false}
                    totalPages={pageInfo.totalPages}
                    pageLimit={pageLimitInfo.pageLimit}
                    onPageChanged={onPageChanged}
                    disablePagination={disablePagination}
                    setIsRefreshPage={setIsRefreshPage}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div className="message text-center">
            <img src={no_user} alt="" className="no_message" />
            <p className="noData text-muted text-center h4 mb-0">
              <FormattedMessage id="no_schedule_history" />
            </p>
            <p className="mb-3">{formatMessage("no_schedule_history_msg")}</p>
            {isOperationPermitted(systemModuleEnum.Fota, "Add") && (
              <LoaderButton
                text="add_schedule"
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) =>
                  openSchedulePopupHandler({ Id: -1, Version: "" }, e)
                }
              />
            )}
          </div>
        )}
      </div>
      <SlidingPanel
        type={"right"}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel order_details_panel">
          <div className="row bb p-2 g-0">
            <div className="col-lg-11">
              <h2 className="fw-bold mb-0 mt-2">
                {selectedRow.EffectiveDateTimestamp}
              </h2>
            </div>
            <div className="col-lg-1 text-end">
              <button
                onClick={closePanelhandler}
                className="Crossicons"
                title={formatMessage("close")}
              >
                <svg
                  role="button"
                  xlinkTitle="close"
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  fill="currentColor"
                  className="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
              </button>
            </div>
          </div>
          <FotaTenantDetails
            selectedData={selectedRow}
          />
        </div>
      </SlidingPanel>
    </>
  );
};

export default ScheduleUpdatePopupHOC(DeletePopupHOC(ShowPopupHOC(AddPopupHOC(observer(FotaReleaseSchedulerHistory)))));
